// extracted by mini-css-extract-plugin
export default {"container":"EditPatientSubmenu_container__2pjH9","menuItemsContainer":"EditPatientSubmenu_menuItemsContainer__3BHoM"};